import { CHANNELS } from "../../shared/channels";
import { call } from "../bridge";
import { byId } from "../dom";
import { isViewActive, onViewHidden, onViewShown, showView } from "../navigation";

// for when a cat walks on the keyboard: the view grabs every key, writes cat noises on a fresh note instead
// and alt+p is the only way out

const SOUNDS = ["meow", "meow", "meow", "wow", "miau", "meo", "nya", "mew", "mrrp", "prrr", "mrow", "nyaa", "miaow", "mrrrow", "purr", "mya", "nyan", "meeow", "mrp", "hiss"];
const MODIFIERS = new Set(["Shift", "Control", "Alt", "Meta", "AltGraph", "CapsLock", "OS"]);
const SAVE_MS = 400;

let noteName = "";
let text = "";
let saveTimer = 0;

const pad = (value: number) => String(value).padStart(2, "0");

function newNoteName(): string {
  const now = new Date();
  return `cat ${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
}

function paper(): HTMLElement {
  return byId("cat-paper");
}

function flush(): void {
  window.clearTimeout(saveTimer);
  saveTimer = 0;
  if (noteName && text) void call(CHANNELS.notesSave, noteName, text);
}

function write(piece: string): void {
  text += piece;
  paper().textContent = text;
  paper().scrollTop = paper().scrollHeight;
  window.clearTimeout(saveTimer);
  saveTimer = window.setTimeout(flush, SAVE_MS);
}

function meow(event: KeyboardEvent): string {
  if (event.key === "Enter") return "\n";
  const sound = SOUNDS[Math.floor(Math.random() * SOUNDS.length)];
  const shout = event.shiftKey || event.getModifierState("CapsLock");
  const word = shout ? sound.toUpperCase() : sound;
  return `${text && !text.endsWith("\n") ? " " : ""}${word}${Math.random() < 0.15 ? "!" : ""}`;
}

function onKey(event: KeyboardEvent): void {
  if (!isViewActive("cat")) return;
  if (event.altKey && event.code === "KeyP") {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === "keydown") {
      flush();
      showView("notes");
    }
    return;
  }
  // everything else is swallowed so a paw can't trigger shortcuts or type into other fields
  event.preventDefault();
  event.stopPropagation();
  if (event.type !== "keydown" || MODIFIERS.has(event.key)) return;
  write(meow(event));
}

function claimFocus(): void {
  if (isViewActive("cat") && document.activeElement !== paper()) paper().focus();
}

export function setupCatView(): void {
  window.addEventListener("keydown", onKey, true);
  window.addEventListener("keypress", onKey, true);
  window.addEventListener("keyup", (event) => {
    if (isViewActive("cat")) event.preventDefault();
  }, true);
  window.addEventListener("focus", claimFocus);
  document.addEventListener("focusin", claimFocus);
  onViewShown("cat", () => {
    noteName = newNoteName();
    text = "";
    paper().textContent = "";
    byId("cat-note-name").textContent = noteName;
    paper().focus();
  });
  onViewHidden("cat", flush);
}
